// Espelho de `CustomRole::PERMISSIONS` (app/models/custom_role.rb). Serve às metas de rota,
// que são estáticas e precisam da string em JS.
//
// A TELA de montar papel NÃO lê esta lista: ela busca o catálogo em
// `/custom_roles/available_permissions`, para que permissão nova no Ruby apareça sem depender de
// alguém lembrar de mexer aqui. O que mora aqui é só o que a rota precisa saber em tempo de
// build — se uma permissão nova guardar uma tela nova, a meta dela é escrita à mão de todo jeito.
export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
  'poweragents_manage',
  'powerdata_manage',
  'inbox_manage',
  'agent_manage',
  'team_manage',
  'label_manage',
  'attribute_manage',
];

export const ROLES = ['agent', 'administrator', 'client', 'moderator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

// A quebra de 01/10/2026. Cada uma destas era `['administrator']` numa meta de rota.
//
// `administrator` CONTINUA em cada meta ao lado da permissão nova, e isso não é redundância: o
// array de permissões de um administrador é `['administrator']` e nada mais (ver
// `AccountUser#permissions`), então uma meta que listasse só `inbox_manage` trancaria o
// administrador fora da própria configuração.
export const POWER_AGENTS_PERMISSIONS = 'poweragents_manage';

export const POWER_DATA_PERMISSIONS = 'powerdata_manage';

export const INBOX_PERMISSIONS = 'inbox_manage';

export const AGENT_PERMISSIONS = 'agent_manage';

export const TEAM_PERMISSIONS = 'team_manage';

export const LABEL_PERMISSIONS = 'label_manage';

export const ATTRIBUTE_PERMISSIONS = 'attribute_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};
